module.exports = "<h2>{{'menu.categories.products.delete.title' | translate}}</h2>\n\n<p>\n  {{description}}<br/>\n</p>\n\n<div class=\"action-footer\">\n  <button class=\"button secondary\" ng-click=\"cancel()\">{{'common.buttons.cancel' | translate}}</button>\n  <button class=\"button\" ng-click=\"delete()\">{{'common.buttons.delete' | translate}}</button>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/menu/categories/category.delete.modal.html
 ** module id = 597
 ** module chunks = 0
 **/